import { useCallback, useEffect, useState } from 'react';
import { BidderFileGeneratedHandler, BidderFileSource } from 'services/actions/ai_management_files';

const ACCESS_FILE_TIMEOUT = 5000;

type GeneratedFile = { blob: Blob; filename: string } | null;

export function useBidderFileGeneration(
  source: BidderFileSource,
  onFileGenerated: BidderFileGeneratedHandler,
) {
  const [generating, setGenerating] = useState(false);
  const [showAccessFile, setShowAccessFile] = useState(false);

  useEffect(() => {
    if (!showAccessFile) return undefined;
    const timer = window.setTimeout(() => setShowAccessFile(false), ACCESS_FILE_TIMEOUT);
    return () => window.clearTimeout(timer);
  }, [showAccessFile]);

  const generate = useCallback(
    async (build: () => Promise<GeneratedFile>) => {
      if (generating) return;
      setGenerating(true);
      try {
        const generated = await build();
        if (!generated) throw new Error('PDF não gerado');
        onFileGenerated(source, generated.blob, generated.filename);
        setShowAccessFile(true);
      } catch (err) {
        console.error(`Erro ao gerar o arquivo do licitante (${source}):`, err);
        window.alert('Não foi possível gerar o arquivo. Tente novamente.');
      } finally {
        setGenerating(false);
      }
    },
    [generating, onFileGenerated, source],
  );

  return { generating, showAccessFile, generate };
}
